<template>
    <div class="img-group">
        <img
            v-for="(sticker, index) in selectedStickers"
            :key="sticker.src"
            :class="sticker.class"
            :src="sticker.src"
            :alt="sticker.alt"
            :width="sticker.width"
            :height="sticker.height"
            loading="lazy"
            decoding="async"
        />
    </div>
</template>

<script>
const stickers = [
    {
        src: 'https://d2q6ite07t3u1l.cloudfront.net/public/soonhari2026/dev/Uploads/blog/stickers/star-2.webp',
        alt: 'Blue and pink star gem stickers',
        class: 'stargroup',
        width: 640,
        height: 512,
    },
    {
        src: 'https://d2q6ite07t3u1l.cloudfront.net/public/soonhari2026/dev/Uploads/blog/stickers/magnet.webp',
        alt: 'Mango sticker',
        class: 'mango',
        width: 348,
        height: 350,
    },
    {
        src: 'https://d2q6ite07t3u1l.cloudfront.net/public/soonhari2026/dev/Uploads/blog/stickers/patch.webp',
        alt: 'South Korean flag patch sticker',
        class: 'flag',
        width: 576,
        height: 488,
    },
    {
        src: 'https://d2q6ite07t3u1l.cloudfront.net/public/soonhari2026/dev/Uploads/blog/stickers/paperclip.webp',
        alt: 'Paper clip and note sticker',
        class: 'paperclip',
        width: 640,
        height: 640,
    },
    {
        src: 'https://d2q6ite07t3u1l.cloudfront.net/public/soonhari2026/dev/Uploads/blog/stickers/button.webp',
        alt: 'I Love Soju button sticker',
        class: 'lovesoju',
        width: 576,
        height: 576,
    },
    {
        src: 'https://d2q6ite07t3u1l.cloudfront.net/public/soonhari2026/dev/Uploads/blog/stickers/star.webp',
        alt: 'Green star gem sticker',
        class: 'greenstar',
        width: 320,
        height: 309,
    },
];

let nextStickerIndex = 0;

function getNextStickers(count) {
    const selected = [];

    for (let index = 0; index < count; index += 1) {
        selected.push(stickers[(nextStickerIndex + index) % stickers.length]);
    }

    nextStickerIndex = (nextStickerIndex + count) % stickers.length;

    return selected;
}
</script>

<script setup>
const props = defineProps({
    max: {
        type: [Number, String],
        default: 3,
    },
});

const stickerCount = Math.min(Math.max(1, parseInt(props.max, 10) || 3), stickers.length);
const selectedStickers = getNextStickers(stickerCount);
</script>
